module.exports = __webpack_public_path__ + "static/media/nyc.bfccc721.png";